import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrescriberBookingComponent } from './prescriber-booking/prescriber-booking.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
	declarations: [PrescriberBookingComponent],
	imports: [CommonModule, SharedModule]
})
export class PrescriberBookingModule {}
